<div *ngIf="options && selectedRange" class="w-100 custom-slider-range" data-legendnum="2">
  <div class="values d-none">
    <span class="lower value">{{ selectedRange.min }}</span
    >-<span class="upper value">{{ selectedRange.max }}</span>
  </div>
  <div class="values d-flex">
    <span class="lower value input">
      <input
        class="w-100 text-left"
        type="number"
        [(ngModel)]="selectedRange.min"
        (ngModelChange)="updateSelectedRange($event, 'min')"
        [ngModelOptions]="{ updateOn: 'blur' }"
      /> </span
    >&nbsp;-&nbsp;
    <span class="upper value input">
      <input
        class="w-100 text-right"
        type="number"
        [(ngModel)]="selectedRange.max"
        (ngModelChange)="updateSelectedRange($event, 'max')"
        [ngModelOptions]="{ updateOn: 'blur' }"
      />
    </span>
  </div>
  <nz-slider
    nzRange
    [nzMax]="maxRange.max"
    [nzMin]="maxRange.min"
    [(ngModel)]="sliderValue"
    (ngModelChange)="changeNzSlider($event)"
  ></nz-slider>
  <!-- <ngx-slider
    [options]="options"
    [(value)]="selectedRange.min"
    [(highValue)]="selectedRange.max"
    (userChangeEnd)="update($event)"
  ></ngx-slider> -->
</div>
